module.exports = __webpack_public_path__ + "static/img/home-hero-mobile-bg.80aae9d.png";